<!-- =========================================================================================
  File Name: CompanyEdit.vue
  Description: Company Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/company/pixinvent
========================================================================================== -->

<template>
  <div id="page-role-view view-page">
    <vs-alert color="danger" title="Log Not Found" :active.sync="not_found">
      <span>Log record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'log.list'}" class="text-inherit underline">All
        Logs</router-link>
      </span>
    </vs-alert>

    <div v-if="data">
    <vs-row >
      <vs-col>
        <vs-row>
          <vs-col>
            <h2 class="mb-4">{{ data.id }}</h2>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <card-page card-title="Summary">
              <hr class="my-3">
              <div class="vx-row mt-4" v-for="row in summary">
                <div class="vx-col w-full">
                  <div class="vx-row">
                    <div class="vx-col w-1/6"><label class="vs-input--label font-bold">{{  row.label }}</label></div>
                    <div class="vx-col w-1/2">{{ data[row.dataKey] }}</div>
                  </div>
                </div>
              </div>

              <vue-json-pretty
                  class="bg-dark text-white p-5 mt-5"
                  :data="data"
                  highlightSelectedNode
              >
              </vue-json-pretty>
            </card-page>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    </div>



  </div>
</template>

<script>


import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css';
import CardPage from '../../../components/Views/CardPage';


export default {
  components: {
    VueJsonPretty,
    CardPage,
  },
  data () {
    return {
      data: null,
      not_found: false,
      summary: [
        {
          label: 'Date',
          dataKey: 'CreatedDate',
        },
        {
          label: 'Type',
          dataKey: 'Level_Name',
        },
        {
          label: 'Message',
          dataKey: 'Message',
        },
      ]
    }
  },
  computed: {
    id() {
      return this.data.id;
    },
  },
  methods: {
    async fetch(id) {
      try {
        const { data } = await this.$api.logs.get(id);
        this.data = data.data;
      } catch (e) {
        console.error(err)
      } finally {
        if (!this.data) {
          this.not_found = true
        }
      }
    },
  },
  mounted () {
    this.fetch(this.$route.params.id)
  }
}

</script>
<style lang="scss">

</style>
